module.exports = __webpack_public_path__ + "img/google-icon.6bbaa5e8.png";